/**
 * The chevron that says, before the pointer arrives, that this row opens
 * something.
 *
 * One chevron, one colour, one stroke, and always the LAST element in a
 * trailing zone — outboard of any control that navigates away. The reported
 * defect was order, not presence: an open hint sitting inboard of a "Read"
 * link tells a reader the link opens the item.
 */
"use client";
import type { ReactElement } from "react";
import { IconChevronRight } from "@tabler/icons-react";

const HINT_SIZE = 14;
const HINT_STROKE = 1.5;

export function CresultcardOpenHint(): ReactElement {
  return (
    <span
      aria-hidden
      className="cresultcard__open-hint"
      data-el="Cresultcard/OpenHint/Root"
    >
      <IconChevronRight size={HINT_SIZE} stroke={HINT_STROKE} />
    </span>
  );
}
